import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import ProfessionalLife from "@/components/ProfessionalLife";
import Insight from "@/components/Insight";
import Companies from "@/components/Companies";
import CompanyDetail from "@/components/CompanyDetail";
import About from "@/components/About";

Vue.use(Router);

export default new Router({
	routes: [
		{
			path: "/",
			name: "Home",
			component: Home
		},
		{
			path: "/professional-life",
			name: "Professsional Life",
			component: ProfessionalLife
		},
		{
			path: "/insight",
			name: "Insight",
			component: Insight
		},
		{
			path: "/companies",
			name: "Companies",
			component: Companies
		},
		{
			path: "/companies/:slug",
			name: "Company",
			component: CompanyDetail,
			props: true
		},
		{
			path: "/about",
			name: "About",
			component: About
		}
	],
	scrollBehavior(to, from, savedPosition) {
		return { x: 0, y: 0 };
	},
	afterEach(to, from) {
		this.$root.setBackground("");
	}
});



// WEBPACK FOOTER //
// ./src/router/index.js